import { FormControl } from '@angular/forms';
import { Component, OnInit, Input } from '@angular/core';
import { Observable, Subscription, timer, Subject } from 'rxjs';
import {
  startWith,
  debounceTime,
  distinctUntilChanged,
  map,
  switchMap,
  skip
} from 'rxjs/operators';
import { v4 as uuid } from 'uuid';

import { OrderDocumentData } from '../../models/order-document-data.model';
import { OrderDocument } from '../../models/order-document.model';
import { OrderService } from '../../services/order.service';
import { OcrService } from '../../services/ocr.service';

@Component({
  selector: 'app-type-control',
  templateUrl: './type-control.component.html',
  styleUrls: ['./type-control.component.scss']
})
export class TypeControlComponent implements OnInit {
  private debouncer: Subject<string> = new Subject();
  private valueChange: Observable<boolean>;
  private htmlChange: Observable<boolean>;
  @Input() private orderDocument: OrderDocument;
  private _isActive: boolean;
  private _disabled: boolean;
  @Input()
  set disabled(status: boolean) {
    this._disabled = status;
    if (status) {
      this.inputCtrl.disable();
    } else {
      this.inputCtrl.enable();
    }
  }
  get disabled(): boolean {
    return this._disabled;
  }
  id: string;
  @Input() documentData: OrderDocumentData;
  @Input() subscription: Subscription;
  @Input()
  get isActive(): boolean {
    return this._isActive;
  }
  set isActive(val: boolean) {
    this._isActive = val;
  }
  inputCtrl: FormControl;
  isSaving: boolean;
  isSaved: boolean;
  constructor(
    private orderService: OrderService,
    private ocrService: OcrService
  ) {
    this.id = uuid();
    this.htmlChange = this.debouncer.asObservable().pipe(
      map(val => {
        this.documentData.value = val;
        console.log(this.documentData.value);
        return val;
      }),
      skip(1),
      debounceTime(5000),
      distinctUntilChanged(),
      switchMap(val => {
        if (!this.orderDocument.isSaved) {
          this.isSaving = true;
          return orderService.saveDocumentData(
            this.orderDocument,
            this.documentData
          );
        }
        return [];
      })
    );
    this.inputCtrl = new FormControl();
    this.valueChange = this.inputCtrl.valueChanges.pipe(
      map(val => {
        this.documentData.value = val;
        return val;
      }),
      skip(1),
      debounceTime(5000),
      distinctUntilChanged(),
      switchMap(val => {
        if (!this.orderDocument.isSaved) {
          this.isSaving = true;
          return orderService.saveDocumentData(
            this.orderDocument,
            this.documentData
          );
        }
        return [];
      })
    );
  }

  ngOnInit() {
    this.subscription.add(
      this.valueChange.subscribe(val => {
        this.isSaving = false;
        this.isSaved = true;
        setTimeout(() => {
          this.isSaved = false;
        }, 3000);
        this.orderDocument.status = 'PD';
      })
    );

    this.subscription.add(
      this.htmlChange.subscribe(val => {
        this.isSaving = false;
        this.isSaved = true;
        setTimeout(() => {
          this.isSaved = false;
        }, 3000);
        this.orderDocument.status = 'PD';
      })
    );
    this.inputCtrl.setValue(this.documentData.value, { emitEvent: false });
  }

  change(evt: string): void {
    console.log(evt);
    this.debouncer.next(evt);
  }
}
